function getPermissionValues(binding) {
  const value = binding.value
  if (Array.isArray(value)) {
    return value.filter(Boolean)
  }
  return value ? [value] : []
}

function hasPermission(store, permissions) {
  if (!permissions.length) return true
  const buttonPerms = store && store.getters ? (store.getters.buttonPerms || []) : []
  return permissions.some(item => buttonPerms.indexOf(item) > -1)
}

function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

export default {
  install(Vue, store) {
    Vue.directive('permission', {
      inserted(el, binding) {
        const permissions = getPermissionValues(binding)
        if (!hasPermission(store, permissions)) {
          removeElement(el)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/permission.js